<template>
  <div class="bd-navbar">
    <Login />
    <Logout />
    <OnlineStatus />

    <b-navbar
      toggleable="lg"
      type="dark"
      v-bind:class="{
        'navbar-color': this.HGscrollY,
        'navbar-default': !this.HGscrollY,
      }"
    >
      <b-navbar-nav>
        <b-nav-item to="/" id="pjlogo">
          <div id="pjhis">
            <b-img
              rounded
              src="../assets/logo-200x200.png"
              alt="Circle image"
              width="30"
              height="30"
              v-if="darkMode == 'dark'"
            ></b-img>
            <b-img
              rounded
              src="../assets/logo.png"
              alt="Circle image"
              width="30"
              height="30"
              v-if="darkMode != 'dark'"
            ></b-img>
            PjHIS V4.4.5

            {{ this.ChecklogIn() }}
          </div>
        </b-nav-item>
      </b-navbar-nav>
      <!-- 
      <b-nav-form @submit="SearchPatient" name="miniSearchPatient">
        <b-input-group
          size="sm"
          class="toggle-custom"
          v-if="false"
          style="max-width:205px"
        >
          <b-form-input
            size="sm"
            type="number"
            placeholder="Search HN or CID"
            maxlength="13"
            id="cid"
            name="hn"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            v-model="SearchPT"
          ></b-form-input>
          <b-input-group-append>
            <b-button size="sm" type="submit">
              <v-icon name="search" class="icon-custom1"></v-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-nav-form>

      -->

      <div
        v-if="
          this.$store.get('systems@PageWidth') <= 991 &&
            $store.get('systems@LoginStatus')
        "
        class="ml-auto margin-right4px"
      >
        <b-icon-bell-fill
          name="bell"
          class="icon-custom-alert font-color3"
        ></b-icon-bell-fill>
      </div>

      <b-navbar-toggle
        target="nav-collapse-main"
        class="toggle-custom"
      ></b-navbar-toggle>

      <b-collapse
        id="nav-collapse-main"
        class="scrollbar margin-bottom-lg"
        is-nav
        v-bind:style="{
          'max-height': `${this.$store.get('systems@PageHeight') - 50}px`,
        }"
      >
        <b-navbar-nav is-nav v-if="$store.get('systems@LoginStatus')">
          <b-nav-item-dropdown text="OPD">
            <b-dropdown-item to="/PatientEMR">
              Patient EMR
            </b-dropdown-item>
            <b-dropdown-item to="/ever-refer-to-hosxp" v-if="false">
              Ever Refer to HOSxP
            </b-dropdown-item>
            <b-dropdown-item to="/PatientRegister" v-if="false"
              >Patient Register</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="$store.get('systems@LoginStatus')">
          <b-nav-item-dropdown text="IPD">
            <b-dropdown-item to="/round-ward">Round ward</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="$store.get('systems@LoginStatus')">
          <b-nav-item-dropdown text="LAB">
            <b-dropdown-item to="/lab-report" v-show="false"
              >Lab Report</b-dropdown-item
            >
            <b-dropdown-item to="/btr-cross-matching"
              >BTR (Cross Matching)</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav
          is-nav
          v-if="$store.get('systems@LoginStatus')"
          v-show="show"
        >
          <b-nav-item-dropdown text="OTHER">
            <b-dropdown-item to="/files-scan"
              >Manage Files Scan</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="false">
          <b-nav-item-dropdown text="Clinical" right>
            <b-dropdown-item to="/IPDRegister">IPD Register</b-dropdown-item>
            <b-dropdown-item to="/ES">ES</b-dropdown-item>
            <b-dropdown-item to="/RU">RU</b-dropdown-item>
            <b-dropdown-item to="/FA">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="false">
          <b-nav-item-dropdown text="Diagnostics" right>
            <b-dropdown-item to="/IPDRegister">IPD Register</b-dropdown-item>
            <b-dropdown-item to="/ES">ES</b-dropdown-item>
            <b-dropdown-item to="/RU">RU</b-dropdown-item>
            <b-dropdown-item to="/FA">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="false">
          <b-nav-item-dropdown text="Medications" right>
            <b-dropdown-item to="/IPDRegister">IPD Register</b-dropdown-item>
            <b-dropdown-item to="/ES">ES</b-dropdown-item>
            <b-dropdown-item to="/RU">RU</b-dropdown-item>
            <b-dropdown-item to="/FA">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="false">
          <b-nav-item-dropdown text="Workflow" right>
            <b-dropdown-item to="/IPDRegister">IPD Register</b-dropdown-item>
            <b-dropdown-item to="/ES">ES</b-dropdown-item>
            <b-dropdown-item to="/RU">RU</b-dropdown-item>
            <b-dropdown-item to="/FA">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav is-nav v-if="false">
          <b-nav-item-dropdown text="Financial" right>
            <b-dropdown-item to="/IPDRegister">IPD Register</b-dropdown-item>
            <b-dropdown-item to="/ES">ES</b-dropdown-item>
            <b-dropdown-item to="/RU">RU</b-dropdown-item>
            <b-dropdown-item to="/FA">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-form @submit="SearchPatient">
            <b-input-group size="sm">
              <b-form-input
                size="sm"
                type="number"
                placeholder="Search HN or CID"
                maxlength="13"
                id="cid"
                name="hn"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                v-model="SearchPT"
              ></b-form-input>
              <b-input-group-append>
                <b-button size="sm" type="submit">
                  <v-icon name="search" class="icon-custom1"></v-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-nav-form>

          <b-nav-item
            v-if="
              this.$store.get('systems@PageWidth') > 991 &&
                $store.get('systems@LoginStatus')
            "
          >
            <b-icon-bell-fill
              name="bell"
              class="icon-custom-alert font-color3 margin-top4px margin-left4px"
            ></b-icon-bell-fill>
          </b-nav-item>

          <b-nav-item-dropdown right v-if="$store.get('systems@LoginStatus')">
            <b-dropdown-item
              to="/profile"
              v-if="$store.get('systems@LoginData')"
              >Profile</b-dropdown-item
            >

            <b-dropdown-item
              to="/e-form-settings"
              v-if="$store.get('systems@LoginData')"
              >eForm Settings
            </b-dropdown-item>

            <template slot="button-content"
              ><em
                ><v-icon
                  name="settings"
                  class="icon-custom1 margin-top4px"
                ></v-icon></em
            ></template>
            <b-dropdown-item v-if="$store.get('systems@LoginData')">
              <div
                class="clearfix border-radius"
                style="
                  padding-left: 0px;
                  padding-right: 0px;
                  padding-top: 1px;
                  padding-bottom: 1px;
                "
              >
                <div
                  @click="changThemeColor('')"
                  class="float-left app-color-circle"
                >
                  <md-icon
                    style="color: #ffffff;"
                    v-b-tooltip.hover="'White theme'"
                    >color_lens</md-icon
                  >
                </div>
                <div
                  @click="changThemeColor('dark')"
                  class="float-left margin-left4px app-color-circle"
                >
                  <md-icon
                    style="color: #000000;"
                    v-b-tooltip.hover="'Dark theme'"
                    >color_lens</md-icon
                  >
                </div>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              @click="$bvModal.show('modal-login')"
              v-if="!$store.get('systems@LoginStatus')"
              >Sign In</b-dropdown-item
            >
            <b-dropdown-item
              @click="$bvModal.show('modal-logout')"
              v-if="$store.get('systems@LoginStatus')"
              >Sign Out</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav>
          <b-nav-item
            @click="$bvModal.show('modal-login')"
            v-if="!$store.get('systems@LoginStatus')"
            >Login</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <notifications
      group="foo-css-navbar"
      position="top center"
      animation-name="v-fade-center"
      :speed="600"
    >
    </notifications>

    <notifications
      group="custom-save-navbar"
      :speed="600"
      animation-name="v-fade-center"
      position="left center"
    >
      <template slot="body" slot-scope="props">
        <div class="custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="
              transition-timing-function: ease;
              transition-delay: 0s;
              transition-property: all;
            "
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import Login from "@/components/Login";
import Logout from "@/components/Logout";
import pjFunctions from "@/functions/pjFunctions";
import thaiDatetime from "@/functions/thaiDatetime";
import store from "@/store/store";
import { Component, Vue } from "vue-property-decorator";
import { sync } from "vuex-pathify";
import OnlineStatus from "./OnlineStatus"; // @ is an alias to /src

// import VueSession from 'vue-session'

// Vue.use(VueSession, options)

@Component({
  components: {
    OnlineStatus,
    Logout,
    Login,
  },
  computed: {
    // @see https://davestewart.github.io/vuex-pathify/#/api/component
    ...sync("*"),
  },
  data: function() {
    return {
      //id is name of the dynamic segment we created in router
      userId: this.$route.path,
      HGscrollY: false,
      SearchPT: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      LoginCHK: null,
      darkMode: "",
    };
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.LoginCHK = "";
  },
  mounted() {
    this.darkMode = localStorage.getItem("theme");

    // set 'app-background' class to body tag
    let bodyElement = document.body;
    bodyElement.classList.add("app-background");
    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");
    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = "dark";
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = "light";
    }
  },
  watch: {
    LoginCHK: function() {
      this.ChecklogIn();
    },
    darkMode: function() {
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;

      if (this.darkMode <= "") {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
      if (this.darkMode == "dark") {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      }
      if (this.darkMode == "light") {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random(),
        },
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    changThemeColor(themeColor) {
      if (localStorage.theme != themeColor) {
        localStorage.theme = themeColor;
        this.darkMode = themeColor;
        // console.log('ssss', this.darkMode)
        // store.set("systems@SpinnersShow", true);
        // setTimeout(() => {
        // window.location.reload(true);
        // }, 500);
      }
    },
    ChecklogIn() {
      if (
        this.$store.get("systems@ApiKey") <= "" ||
        this.$store.get("systems@ApiKey") == "undefined" ||
        this.$store.get("systems@ApiKey") == null
      ) {
        this.$bvModal.show("modal-login");
      }
    },
    SearchPatient(e) {
      e.preventDefault();

      let Shn = "";
      let Scid = "";

      if (this.SearchPT.length == 9 || this.SearchPT.length == 13) {
        if (this.SearchPT.length == 9) {
          Shn = this.SearchPT;
          Scid = "";
        }

        if (this.SearchPT.length == 13) {
          Shn = "";
          Scid = this.SearchPT;
        }

        let currentObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "PatientData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: Shn,
            cid: Scid,
          })
          .then(function(response) {
            currentObj.output = response.data;
            if (currentObj.output.status === true) {
              store.set("systems@SearchPT", true);
              store.set("systems@SearchPTid", currentObj.output.result.hn);

              currentObj.$root.$emit(
                "bv::toggle::collapse",
                "nav-collapse-main"
              );

              /*
              currentObj.$root.$on(
                "bv::collapse::state",
                (collapseId, isJustShown) => {
                  console.log("collapseId:", collapseId);
                  console.log("isJustShown:", isJustShown);

                  if (
                    collapseId == "nav-collapse-main" &&
                    isJustShown == true &&
                    st == "SearchPatient"
                  ) {
                    currentObj.$root.$emit(
                      "bv::toggle::collapse",
                      "nav-collapse-main"
                    );
                    let st = "";
                  }
                }
              );
              */

              if (currentObj.$route.params.hn != currentObj.output.result.hn) {
                currentObj.$router.push({
                  path: "/PatientEMR/" + currentObj.output.result.hn,
                });
              }
            } else {
              currentObj.show(
                "foo-css-navbar",
                "warn",
                "Invalid HN or CID ",
                "ไม่พบ HN หรือ CID ที่คุณต้องการค้นหา -_- ! <br>Date : " +
                  currentObj.thaiDatetimeFc.ThaiDateTime(
                    currentObj.thaiDatetimeFc.DateTimeNow()
                  )
              );
            }
          })
          .catch(function(error) {
            currentObj.output = error;
            currentObj.show(
              "foo-css-navbar",
              "error",
              "Search Patient Error",
              currentObj.output +
                " -_- ! <br>Date : " +
                currentObj.thaiDatetimeFc.ThaiDateTime(
                  currentObj.thaiDatetimeFc.DateTimeNow()
                )
            );
          });
      } else {
        this.show(
          "foo-css-navbar",
          "warn",
          "Error HN and CID ",
          "คุณกรอก HN หรือ CID ไม่ถูกต้อง -_- ! <br>Date : " +
            this.thaiDatetimeFc.ThaiDateTime(this.thaiDatetimeFc.DateTimeNow())
        );
      }
    },
    handleScroll() {
      let scrollY = window.scrollY;
      let scrollX = window.scrollX;

      if (scrollY >= 20 && this.HGscrollY == false) {
        this.HGscrollY = true;
        // if(this.$store.get('systems@scrollChangColor') != true){
        // store.set('systems@scrollChangColor', true)
        // }
      }

      if (scrollY < 20 && this.HGscrollY == true) {
        this.HGscrollY = false;
        // if(this.$store.get('systems@scrollChangColor') == true){
        // store.set('systems@scrollChangColor', false)
        // }
      }
    },
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
})
export default class Navbar extends Vue {}
</script>

<style lang="scss">
.nav-link.active {
  color: #41b883 !important;
}

.icon-custom-alert {
  font-size: 24px !important;
}

.toggle-custom {
  padding-right: 8px;
  padding-left: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.dropdown-item:focus,
.dropdown-item:hover {
  color: #ffffff !important;
  text-decoration: none !important;
  background-color: hsla(0, 0%, 100%, 0.1) !important;
}

.dropdown-item.active,
.dropdown-item:active {
  //background-color: #D3AA4B !important;
  background-color: #41b883 !important;
  color: #000000 !important;
}

#pjhis {
  color: #41b883 !important;
  font-weight: bold !important;
  vertical-align: middle !important;
  font-size: 20px !important;
  // margin-left: 20px;
}

.navbar {
  padding: 0.2rem 1rem !important;
}

.bd-navbar {
  position: -webkit-sticky;
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
}

#pjlogo,
a {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.scrollbar {
  // max-height: { $store.getters.scrollChangColor }};
  overflow: auto;
}

#nav-collapse::-webkit-scrollbar {
  width: 3px;
  background-color: rgba(0, 0, 0, 0);
}

#nav-collapse::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

#nav-collapse::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.0);
  background-color: rgba(0, 0, 0, 0);
  border-radius: 5px;
}

#nav-collapse::-webkit-scrollbar-track-piece {
  height: 5px;
  border-radius: 5px;
}

@media (min-width: 992px) {
  .scrollbar {
    overflow: unset !important;
  }
}
</style>
